import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preview-campaign',
  templateUrl: './preview-campaign.component.html',
  styleUrls: ['./preview-campaign.component.css']
})
export class PreviewCampaignComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
